/* eslint-disable camelcase */
// Axios
import axios from 'axios';

// Constants
import ENVS from 'constants/enviroments';
import STATE_LIST from 'constants/states';
import MAP from 'constants/map';

export const Algolia = {
  /**
   * Turns geographic coordinates into place names.
   */
  reverseGeocoding: async ({ lat, lng }: { lat: number; lng: number }) => {
    try {
      const algoliaPlacesURL = `${ENVS.ALGOLIA_PLACES_URL}/reverse`;
      const parsedLat = parseFloat(String(lat));
      const parsedLng = parseFloat(String(lng));

      const { data, status } = await axios.get(algoliaPlacesURL, {
        params: {
          aroundLatLng: `${parsedLat},${parsedLng}`,
          hitsPerPage: 1,
          language: 'pt',
        },
      });

      if (status === 200) {
        return data;
      }
    } catch (err) {}
    return null;
  },
  /**
   * Converts and formats a algolia place(result) to an object that has
   * cep, street, neigh, city and state.
   */
  placeToAddress: (data: any) => {
    if (Array.isArray(data.hits) && data.hits.length > 0) {
      const { postcode, locale_names, suburb, city, administrative } =
        data.hits[0] || {};
      const fullState = ((administrative?.[0] as string) || '').toLowerCase();
      const state = STATE_LIST.find((s) => s.name.toLowerCase() === fullState)
        ?.abbreviation;

      return {
        cep: postcode?.[0] || '',
        street: locale_names?.[0] || locale_names?.default?.[0] || '',
        neigh: suburb?.[0] || '',
        city: city?.[0] || city?.default?.[0] || '',
        state: state || '',
      };
    }
    return null;
  },
};

export const Here = {
  geoCoding: async (cep: string) => {
    try {
      const geocodeHereURL = `${ENVS.HERE_URL}/geocode`;

      const { data, status } = await axios.get(geocodeHereURL, {
        params: {
          apiKey: ENVS.HERE_API_KEY,
          q: cep,
        },
      });

      if (status === 200) return data;
    } catch (error) {
      // Do nothing
    }
    return null;
  },
  autosuggest: async (cep: string) => {
    try {
      const geocodeHereURL = `${ENVS.HERE_URL}/autosuggest`;

      const { data, status } = await axios.get(geocodeHereURL, {
        params: {
          apiKey: ENVS.HERE_API_KEY,
          in: MAP.BOUNDING_BOX_BRAZIL,
          q: cep,
        },
      });

      if (status === 200) return data;
    } catch (error) {
      // Do nothing
    }
    return null;
  },
};
